var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"short-answer"},[_c('el-input',{attrs:{"id":`question_${_vm.index}`,"name":`question_${_vm.index}_${_vm.data._id}`},on:{"input":_vm.handleChange},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }